import { useEffect } from "react";
import { useParams } from "react-router-dom";

import { useBlogArticleSelectors } from "../store/blogArticle/blogArticle.selectors";

import { useDispatchedActions } from "./use-dispatch-actions";

export const useGetBlogArticle = () => {
  const { data } = useBlogArticleSelectors();

  const { slug } = useParams();
  const { getBlogArticle } = useDispatchedActions();

  useEffect(() => {
    if (data?.slug === slug) return;
    getBlogArticle(slug);
  }, [slug]);
};
